module.exports = __webpack_public_path__ + "img/doctors_banner.ad93bea0.svg";